export default {
  currentImage: function currentImage(state) {
    return state.currentImage;
  },
  productInspiration: function productInspiration(state) {
    return state.productInspiration;
  },
  productCross: function productCross(state) {
    return state.productCross;
  },
  productComplementary: function productComplementary(state) {
    return state.productComplementary;
  },
  productXsellAddToCart: function productXsellAddToCart(state) {
    return state.productXsellAddToCart;
  },
  variants: function variants(state) {
    return state.variants;
  },
  product: function product(state) {
    return state.product;
  },
  breadcrumb: function breadcrumb(state) {
    var _state$product;
    return ((_state$product = state.product) === null || _state$product === void 0 ? void 0 : _state$product.breadcrumbDisplay) || null;
  },
  productRR: function productRR(state) {
    return state.productRR;
  }
};